import axios from 'axios';
import { getBackendHost } from '../utils/backendHost';


const authConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('jwt_authorization')}`,
  },
});


export async function getOrganization(organizationId) {
  const response = await axios.get(
    `${getBackendHost()}/v2/organization/${organizationId}`,
    authConfig(),
  );
  return response.data;
}


export async function updateOrganization(organizationId, organization) {
  const response = await axios.put(
    `${getBackendHost()}/v2/organization/${organizationId}`,
    organization,
    authConfig(),
  );
  return response.data.organization;
}


export async function getOrganizationMembers(organizationId) {
  const response = await axios.get(
    `${getBackendHost()}/v2/organization/${organizationId}/members`,
    authConfig(),
  );
  return response.data;
}


export async function createOrganizationMember(organizationId, member) {
  const response = await axios.post(
    `${getBackendHost()}/v2/organization/${organizationId}/members`,
    member,
    authConfig(),
  );
  return response.data.member;
}


export async function getOrganizationInvitations(organizationId) {
  const response = await axios.get(
    `${getBackendHost()}/v2/organization/${organizationId}/invitations`,
    authConfig(),
  );
  return response.data.invitations || [];
}


export async function createOrganizationInvitation(organizationId, invitation) {
  const response = await axios.post(
    `${getBackendHost()}/v2/organization/${organizationId}/invitations`,
    invitation,
    authConfig(),
  );
  return response.data.invitation;
}


export async function resendOrganizationInvitation(organizationId, invitationId) {
  const response = await axios.post(
    `${getBackendHost()}/v2/organization/${organizationId}/invitations/${invitationId}/resend`,
    {},
    authConfig(),
  );
  return response.data.invitation;
}


export async function revokeOrganizationInvitation(organizationId, invitationId) {
  await axios.delete(
    `${getBackendHost()}/v2/organization/${organizationId}/invitations/${invitationId}`,
    authConfig(),
  );
}


export async function getOrganizationInvitation(token) {
  const response = await axios.get(
    `${getBackendHost()}/v2/organization-invitations/${encodeURIComponent(token)}`,
  );
  return response.data.invitation;
}


export async function acceptOrganizationInvitation(token, values) {
  const response = await axios.post(
    `${getBackendHost()}/v2/organization-invitations/${encodeURIComponent(token)}/accept`,
    values,
  );
  return response.data;
}


export async function updateOrganizationMember(organizationId, memberId, member) {
  const response = await axios.put(
    `${getBackendHost()}/v2/organization/${organizationId}/members/${memberId}`,
    member,
    authConfig(),
  );
  return response.data.member;
}


export async function deleteOrganizationMember(organizationId, memberId) {
  await axios.delete(
    `${getBackendHost()}/v2/organization/${organizationId}/members/${memberId}`,
    authConfig(),
  );
}


export async function getMessageDeliverySettings() {
  const response = await axios.get(
    `${getBackendHost()}/v2/message-delivery/settings`,
    authConfig(),
  );
  return response.data.settings;
}


export async function updateMessageDeliverySettings(settings) {
  const response = await axios.put(
    `${getBackendHost()}/v2/message-delivery/settings`,
    settings,
    authConfig(),
  );
  return response.data.settings;
}

export async function updateReportPreferences(organizationId, memberId, preferences) {
  const response = await axios.put(
    `${getBackendHost()}/v2/organization/${organizationId}/members/${memberId}/report-preferences`,
    preferences,
    authConfig(),
  );
  return response.data.member;
}
